module.exports = __webpack_public_path__ + "static/media/Pic-0548.8bd320dc.jpg";